import { createSelector } from '@reduxjs/toolkit';

import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectFileUploadsByIdSelector } from 'src/selectors/projectFileUploadsById';
import { projectVirtualGraphsByIdSelector } from 'src/selectors/projectVirtualGraphsById';
import { getValidMappingsByResource } from 'src/utils/export/validateMappingsByResource';

export const hasValidMappingsSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      diagramSnapshotSelector(projectId),
      projectFileUploadsByIdSelector(projectId),
      projectVirtualGraphsByIdSelector(projectId),
      (diagramSnapshot, fileUploads, virtualGraphs) => {
        const validResources = diagramSnapshot
          ? getValidMappingsByResource(diagramSnapshot.model)
              .classMappingsByResource
          : {};
        return (
          Object.keys(fileUploads).some((id) => validResources[id]) ||
          Object.keys(virtualGraphs).some((id) => validResources[id])
        );
      }
    )
);
